<template>
  <div class="sky-hc-bulletin-board">
    <div>
      <DecentralizedOrgChart />
    </div>
  </div>
</template>
<script>
import DecentralizedOrgChart from './components/decentralizedOrgChart'
export default {
  name: 'BulletinBoard',
  components: {
    DecentralizedOrgChart
  }
}
</script>
